import { Module } from '../../ts/Module';

Module.instance().directive('tbWindowMaxWidth', <any[]>[
  '$window',
  ($window: ng.IWindowService) => {
    return {
      restrict: 'A',
      link: (scope: ng.IScope, elm: JQuery, attrs: ng.IAttributes) => {
        const syncToWindowWidth = () => elm.css('maxWidth', $($window).width());

        syncToWindowWidth();
        $($window).on('resize', syncToWindowWidth);

        elm.on('$destroy', () => {
          $($window).off('resize', syncToWindowWidth);
        });
      }
    };
  }
]);
